/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceGalleryImage
 */
export interface SurfaceGalleryImage {
    /**
     * 
     * @type {string}
     * @memberof SurfaceGalleryImage
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceGalleryImage
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceGalleryImage
     */
    caption?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceGalleryImage
     */
    alt?: string;
}

/**
 * Check if a given object implements the SurfaceGalleryImage interface.
 */
export function instanceOfSurfaceGalleryImage(value: object): value is SurfaceGalleryImage {
    return true;
}

export function SurfaceGalleryImageFromJSON(json: any): SurfaceGalleryImage {
    return SurfaceGalleryImageFromJSONTyped(json, false);
}

export function SurfaceGalleryImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceGalleryImage {
    if (json == null) {
        return json;
    }
    return {
        
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'caption': json['caption'] == null ? undefined : json['caption'],
        'alt': json['alt'] == null ? undefined : json['alt'],
    };
}

export function SurfaceGalleryImageToJSON(json: any): SurfaceGalleryImage {
    return SurfaceGalleryImageToJSONTyped(json, false);
}

export function SurfaceGalleryImageToJSONTyped(value?: SurfaceGalleryImage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'imageId': value['imageId'],
        'imageUrl': value['imageUrl'],
        'caption': value['caption'],
        'alt': value['alt'],
    };
}

